module.exports = __webpack_public_path__ + "static/img/active3.c5a08b17.png";